import { c as _c } from "react/compiler-runtime";
import type { RequestError } from '@onefootprint/request';
import request from '@onefootprint/request';
import type { GetD2PRequest, GetD2PResponse } from '@onefootprint/types';
import { AUTH_HEADER } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
type GetD2PStatusPollArgs = {
  enabled?: boolean;
  refetchInterval?: number | false;
  authToken: string;
  options?: {
    onSuccess?: (response: GetD2PResponse) => void;
    onError?: (error: RequestError) => void;
  };
};
const D2P_STATUS_FETCH_INTERVAL = 1000;
const getD2PStatus = async (payload: GetD2PRequest) => {
  const {
    data: response
  } = await request<GetD2PResponse>({
    method: 'GET',
    url: '/hosted/onboarding/d2p/status',
    headers: {
      [AUTH_HEADER]: payload.scopedAuthToken
    }
  });
  return response;
};
const useGetD2PStatus = t0 => {
  const $ = _c(22);
  const {
    authToken,
    enabled: t1,
    refetchInterval: t2,
    options: t3
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const refetchInterval = t2 === undefined ? D2P_STATUS_FETCH_INTERVAL : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const options = t4;
  let t5;
  if ($[2] !== authToken || $[3] !== enabled) {
    t5 = ["get-d2p-status", authToken, enabled];
    $[2] = authToken;
    $[3] = enabled;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== authToken) {
    t6 = () => getD2PStatus({
      scopedAuthToken: authToken ?? ""
    });
    $[5] = authToken;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = !!authToken && !!enabled;
  let t8;
  if ($[7] !== refetchInterval || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7,
      refetchInterval
    };
    $[7] = refetchInterval;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const query = useQuery(t8);
  let t9;
  if ($[12] !== options || $[13] !== query.data || $[14] !== query.error || $[15] !== query.isError) {
    t9 = () => {
      if (query.data) {
        options.onSuccess?.(query.data);
      }
      if (query.isError) {
        options.onError?.(query.error as RequestError);
      }
    };
    $[12] = options;
    $[13] = query.data;
    $[14] = query.error;
    $[15] = query.isError;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== query.data || $[18] !== query.error || $[19] !== query.isError || $[20] !== query.isSuccess) {
    t10 = [query.isSuccess, query.isError, query.error, query.data];
    $[17] = query.data;
    $[18] = query.error;
    $[19] = query.isError;
    $[20] = query.isSuccess;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  useEffect(t9, t10);
  return query;
};
export default useGetD2PStatus;